import { lazy } from "react";
import { Navigate, type RouteObject } from "react-router";

const SettingsIndex = lazy(() => import("@/app/(main)/settings/page"));
const Roles = lazy(() => import("@/app/(main)/settings/roles/page"));
const Branches = lazy(() => import("@/app/(main)/settings/branches/page"));
const CustomFields = lazy(() => import("@/app/(main)/settings/custom-fields/page"));
const Numbering = lazy(() => import("@/app/(main)/settings/numbering/page"));
const Channels = lazy(() => import("@/app/(main)/settings/channels/page"));
const ModulesSettings = lazy(() => import("@/app/(main)/settings/modules/page"));

// Users
const Users = lazy(() => import("@/app/(main)/settings/users/page"));
const UserDetail = lazy(() => import("@/app/(main)/settings/users/[id]/page"));

// Print Templates
const PrintTemplates = lazy(() => import("@/app/(main)/settings/print-templates/page"));
const PrintTemplateDetail = lazy(() => import("@/app/(main)/settings/print-templates/[id]/page"));

// Automation
const Automation = lazy(() => import("@/app/(main)/settings/automation/page"));
const AutomationDetail = lazy(() => import("@/app/(main)/settings/automation/[id]/page"));

// Jobs
const Jobs = lazy(() => import("@/app/(main)/settings/jobs/page"));
const JobDetail = lazy(() => import("@/app/(main)/settings/jobs/[id]/page"));

// Webhooks
const Webhooks = lazy(() => import("@/app/(main)/settings/webhooks/page"));
const WebhookDetail = lazy(() => import("@/app/(main)/settings/webhooks/[id]/page"));

// Data
const DataExport = lazy(() => import("@/app/(main)/settings/data/export/page"));
const DataImport = lazy(() => import("@/app/(main)/settings/data/import/page"));

// Email
const Email = lazy(() => import("@/app/(main)/settings/email/page"));
const EmailTemplates = lazy(() => import("@/app/(main)/settings/email/templates/page"));
const EmailTemplateDetail = lazy(() => import("@/app/(main)/settings/email/templates/[id]/page"));

// Billing
const Billing = lazy(() => import("@/app/(main)/settings/billing/page"));
const BillingPlans = lazy(() => import("@/app/(main)/settings/billing/plans/page"));
const BillingHistory = lazy(() => import("@/app/(main)/settings/billing/history/page"));

// Reports
const Reports = lazy(() => import("@/app/(main)/settings/reports/page"));
const ReportDetail = lazy(() => import("@/app/(main)/settings/reports/[id]/page"));

// Company
const Company = lazy(() => import("@/app/(main)/settings/company/page"));
const CompanyAccounting = lazy(() => import("@/app/(main)/settings/company/accounting/page"));

// Doctypes (Doctype Admin Epic #347, A3 #351) — doctype-agnostic registry UI
const Doctypes = lazy(() => import("@/app/(main)/settings/doctypes/page"));
const DoctypeDetail = lazy(() => import("@/app/(main)/settings/doctypes/[id]/page"));

export const settingsRoutes: RouteObject[] = [
  { index: true, element: <Navigate to="/settings/dashboard" replace /> },
  { path: "dashboard", Component: SettingsIndex },
  { path: "roles", Component: Roles },
  { path: "branches", Component: Branches },
  { path: "custom-fields", Component: CustomFields },
  { path: "numbering", Component: Numbering },
  { path: "channels", Component: Channels },
  { path: "modules", Component: ModulesSettings },

  // Users
  { path: "users", Component: Users },
  { path: "users/:id", Component: UserDetail },

  // Print Templates
  { path: "print-templates", Component: PrintTemplates },
  { path: "print-templates/:id", Component: PrintTemplateDetail },

  // Automation
  { path: "automation", Component: Automation },
  { path: "automation/:id", Component: AutomationDetail },

  // Jobs
  { path: "jobs", Component: Jobs },
  { path: "jobs/:id", Component: JobDetail },

  // Webhooks
  { path: "webhooks", Component: Webhooks },
  { path: "webhooks/:id", Component: WebhookDetail },

  // Data
  { path: "data/export", Component: DataExport },
  { path: "data/import", Component: DataImport },

  // Email
  { path: "email", Component: Email },
  { path: "email/templates", Component: EmailTemplates },
  { path: "email/templates/:id", Component: EmailTemplateDetail },

  // Billing
  { path: "billing", Component: Billing },
  { path: "billing/plans", Component: BillingPlans },
  { path: "billing/history", Component: BillingHistory },

  // Reports
  { path: "reports", Component: Reports },
  { path: "reports/:id", Component: ReportDetail },

  // Company
  { path: "company", Component: Company },
  { path: "company/accounting", Component: CompanyAccounting },

  // Doctypes
  { path: "doctypes", Component: Doctypes },
  { path: "doctypes/:id", Component: DoctypeDetail },
];
